import { extendObservable } from "mobx";
import * as _ from "lodash";
import { validate } from "util";

export default class BaseEntity {
  constructor(params) {
    const finalParams = _.merge({}, this.defaultParams(), params);
    Object.assign(this, finalParams);
    extendObservable(this, finalParams);

    this.errors = [];
  }

  defaultParams() {
    return {};
  }

  getServiceObject() {
    return this;
  }

  // TODO: Constraint should be defined by the entity itself.
  // TODO: Entities should have one and only one validation constraint
  validate(constraint) {
    const validation = validate(this, constraint, { fullMessages: false });

    this.errors = {};

    if (!!validation) {
      Object.entries(validation).forEach(
        ([field, errors]) => (this.errors[field] = errors.join(", "))
      );
    }

    return Object.keys(this.errors).length === 0;
  }
}



// WEBPACK FOOTER //
// ./src/core/entity/base.entity.js